import { render, staticRenderFns } from "./ModalSolicitacaoPendencia.vue?vue&type=template&id=7588b30e&scoped=true"
import script from "./ModalSolicitacaoPendencia.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoPendencia.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoPendencia.vue?vue&type=style&index=0&id=7588b30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7588b30e",
  null
  
)

export default component.exports